
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class LocationTransferBOMGrid extends Serenity.EntityGrid<LocationTransferBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.LocationTransferBOM'; }
        protected getDialogType() { return LocationTransferBOMDialog; }
        protected getIdProperty() { return LocationTransferBOMRow.idProperty; }
        protected getInsertPermission() { return LocationTransferBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return LocationTransferBOMRow.localTextPrefix; }
        protected getService() { return LocationTransferBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}